import { useState } from 'react';
export function useDialogToggle(initState) {
    const [dialog, setDialogState] = useState(initState);
    function openDialog(id) {
        const newState = { ...dialog, [id]: true };
        setDialogState(newState);
    }
    function closeDialog() {
        const newState = {};
        for (const id in dialog) {
            newState[id] = false;
        }
        setDialogState(newState);
    }
    return { dialog, closeDialog, openDialog };
}
